import React from 'react';
import TreeEntity from './treeEntity';


/**Creates the first layer of the tree
 * So the recurisive tree entity can do its thing
 */
function Tree(props) {
    let treeMapper;
    if (props.tree) {
        treeMapper = props.tree.map((list => {
            /**Adding more data to a node, then add here this is so it can be passed through to the modal*/
            return (
                <TreeEntity key={list.id} id={list.id} name={list.name} children={list.children} templateId={list.templateId}
                    addEvent={props.addEvent} type={list.type} shortName={list.shortName} sources={list.sources} theme={list.theme}
                    notes={list.notes} flatten={list.flatten} looseFiles={list.looseFiles} colour={list.colour} readOnly={props.readOnly} />
            );
        }));
    }

    return (
        <div className="tree-root" id="tree-root">
            <TreeEntity name="sites/Intranet" id="0" readOnly={props.readOnly} addEvent={props.addEvent} type="root" colour={"#d2b48c"} />
            <div className="tree-children">
                {treeMapper}
            </div>
        </div>

    );
}

export default Tree;



// WEBPACK FOOTER //
// ./src/components/tree/node/tree.js